module.exports = __webpack_public_path__ + "static/media/tenth_southside_school.dbebe84e.mp4";